module.exports = __webpack_public_path__ + "img/06.f7f86490.png";